import React from 'react';

import PlaceholderWidget from '/client/app/components/placeholderWidget/placeholderWidget';

export default function TagStatisticsWidget() {
	return <PlaceholderWidget text="tag statistics widget will go here" />;
}
